import React from "react";
import "./DotsLoader.css";

const DotsLoader = () => {
  return (
    <div className="dots-loader">
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </div>
  );
};

export default DotsLoader;
